import { Filter } from 'components/FilterDrawer/FilterDrawer.config'
import { employeesExport, EMPLOYEES_EXPORT_TYPES, EmployeesExportType } from 'services/employeesApi'
import { downloadCSV } from 'utils/downloadCSV'
import { jsonToCsv } from './JsonToCsvConverter'
import { generateCompleteFileName } from './fileNameGenerator'

interface EmployeesCSVExportParams {
  employeesIndices: string
  entityId: string
  vertical: string
  tin?: string
  onlineName?: string
  filters?: Filter[]
  searchValue?: string
  exportType?: EmployeesExportType
}

const SPECIFIC_ACTIVITY_BY_EXPORT_TYPE: Record<EmployeesExportType, string> = {
  [EMPLOYEES_EXPORT_TYPES.SUMMARY]: 'Employees-Summary',
  [EMPLOYEES_EXPORT_TYPES.DETAILED]: 'Employees-Detailed',
}

export const onEmployeesCSVExport = async ({
  employeesIndices,
  entityId,
  vertical,
  tin,
  onlineName,
  filters,
  searchValue,
  exportType = EMPLOYEES_EXPORT_TYPES.SUMMARY,
}: EmployeesCSVExportParams): Promise<void> => {
  try {
    const { employees, headers } = await employeesExport({
      employeesIndices,
      entityId,
      vertical,
      filters,
      searchValue,
      exportType,
    })
    const employeesCSV = jsonToCsv(employees, headers)

    const fileName = generateCompleteFileName({
      vertical: vertical,
      exportType: 'specific-activity',
      specificActivityType: SPECIFIC_ACTIVITY_BY_EXPORT_TYPE[exportType],
      tin: tin,
      onlineName: onlineName,
      entityId: entityId,
    })
    const finalFileName = `${fileName}.csv`

    downloadCSV(employeesCSV, finalFileName)
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
